import React from 'react';

import { Trans } from '@lingui/macro';
import Grid from '@mui/material/Grid';
import Icon from '@mui/icons-material/KeyboardTab';
import Typography from '@mui/material/Typography';

import * as S from '../../Sources/Network';
import { AIRCHAIN_TENANT_ID, getStreamPath, getSRTPublishURL, getReadURL, isAvailable } from '../../../../utils/mediamtx';
import BoxTextarea from '../../../../misc/BoxTextarea';
import Textarea from '../../../../misc/Textarea';

const initSettings = (initialSettings, config) => ({
	...S.func.initSettings(initialSettings, config),
	mode: 'pull',
});

function Source(props) {
	const config = S.func.initConfig(props.config);
	const skills = S.func.initSkills(props.skills);
	const settings = initSettings(props.settings, config);

	const mediamtx = props.mediamtxConfig;
	const available = isAvailable(mediamtx);
	const path = getStreamPath(AIRCHAIN_TENANT_ID, config.channelid);

	const handleChange = (newSettings) => {
		newSettings = newSettings || settings;

		if (available) {
			// core connects OUT to the shared MediaMTX ingest -- the input is
			// a real, fully qualified external SRT URL, never shown to the
			// customer. Same underlying pull as InternalRTMP.js; only the
			// customer-facing publish protocol differs between these two tiles.
			newSettings.address = getReadURL(mediamtx, path);
		}

		const inputs = S.func.createInputs(newSettings, config, skills);
		newSettings.address = inputs[0].address;

		props.onChange(id, newSettings, inputs, available);
	};

	React.useEffect(() => {
		handleChange();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!available) {
		return (
			<Grid item xs={12}>
				<Typography>
					<Trans>The ingest service is currently unavailable. Please try again later or choose another source.</Trans>
				</Typography>
			</Grid>
		);
	}

	const publishURL = getSRTPublishURL(mediamtx, path);

	return (
		<React.Fragment>
			<Grid item xs={12}>
				<Typography>
					<Trans>Publish your stream to this address:</Trans>
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<BoxTextarea>
					<Textarea rows={1} value={publishURL} readOnly allowCopy />
				</BoxTextarea>
			</Grid>
		</React.Fragment>
	);
}

Source.defaultProps = {
	settings: {},
	config: null,
	skills: null,
	mediamtxConfig: null,
	onChange: function (type, settings, inputs, ready) {},
};

function SourceIcon(props) {
	return <Icon style={{ color: '#FFF' }} {...props} />;
}

const id = 'srt';
const type = 'network';
const name = <Trans>SRT server</Trans>;
const capabilities = ['audio', 'video'];

export { id, type, name, capabilities, SourceIcon as icon, Source as component };
